<template>
  <div>
      <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <h4>แก้ไขลิงค์ Fanpage&Post</h4>
          <br>
          <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ชื่อลิงค์ Fanpage"
              v-model="nameFanpage" name="username" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ขื่อลิงค์ Fanpage"
              v-model="Fanpage" name="username" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ชื่อลิงค์ Post" v-model="namePost"
              name="post" />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ลิงค์ Post" v-model="post"
              name="post" />
          </div>
          </div>
          <div>
             <div class="mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="เครคิตที่แจก" v-model="creditFree"
              name="creditFree" />
          </div>
          <div class="mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ลิมิตต่อวัน" v-model="userLimit"
              name="userLimit" />
          </div>
          <div class="mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ยอดขั้นต่ำที่ถอนได้" v-model="turnover"
              name="tuanover" />
          </div>
          <div class="mt-8">
            <vs-input :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" class="w-full"  label-placeholder="ยอดเงินที่ได้รับ" v-model="withdraw"
              name="withdraw" />
          </div>
          </div>

          <vs-button :disabled="$store.state.AppActiveUser.permissions.creditfree.action ? false : true" color="success" type="relief" class="mt-8" @click="editlink()">แก้ไข</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios'

export default {
  data () {
    return {
      post:'',
      namePost: '',
      Fanpage:'',
      nameFanpage: '',
      creditFree: '',
      userLimit: '',
      turnover: '',
      withdraw: '',
      info:[],
      status:[],
      log_info: '',
      nameWeb: process.env.VUE_APP_TITLE
    }
  },
  async mounted () {
    await axios
      .get('creditfree/showinfo')
      .then(response => (this.info = response.data))
    this.namePost = this.info[0].name_post
    this.post = this.info[0].post
    this.nameFanpage = this.info[0].name_fanpage
    this.Fanpage = this.info[0].fanpage
    this.creditFree = this.info[0].credit
    this.userLimit = this.info[0].perday
    this.turnover = this.info[0].turnover
    this.withdraw = this.info[0].withdraw
  },
  methods:{
    async editlink () {
      await axios
        .post('creditfree/editinfo', {
          fanpage:this.Fanpage,
          post:this.post,
          credit:this.creditFree,
          turnover:this.turnover,
          withdraw:this.withdraw,
          perday: this.userLimit,
          nameFanpage : this.nameFanpage,
          namePost : this.namePost
        }).then(response => (this.status = response.data))
      if (this.status.status === true) {


        this.$vs.notify({
          time:4000,
          color: 'success',
          position:'top-right',
          icon:  'check_box',
          title: 'ทำรายการสำเร็จ',
          text: this.status.info
        })
      } else {
        this.$vs.notify({
          time:4000,
          color: 'danger',
          position:'top-right',
          icon:  'error',
          title: 'ทำรายการไม่สำเร็จ',
          text: this.status.info
        })
      }
    }
  }


}
</script>

<style>

</style>
